<template>
  <div v-if="excursionUserRiskRatingEnabled" class="risk-rating-overall">
    <v-row class="flex-wrap">
      <v-col cols="12">
        <v-label class="risk-rating-overall-form-label">Overall Rating</v-label>
        <div class="confirmation-info-text">
          <v-icon>fa:fas fa-info-circle</v-icon>
          <span>Confirm an overall risk assessment for this excursion. You can review </span>
          <span v-if="!riskMatrixSelfDefinedDetected">our Risk Assessment Guide </span
          ><span v-if="riskMatrixSelfDefinedDetected">your school's excursion risk matrix </span>
          <span
            v-if="riskMatrixSelfDefinedDetected"
            id="risk-rating-overall--guide-download--link"
            class="text-primary text-decoration-underline"
            style="cursor: pointer"
            @click="downloadRiskAssessmentGuidePdf"
            >here</span
          ><a
            v-if="!riskMatrixSelfDefinedDetected"
            id="risk-rating-overall--risk-assessment-guide--link"
            :href="riskAccessmentGuidePdf"
            class="link-primary"
            target="_blank"
            >here</a
          >.
        </div>
      </v-col>
    </v-row>
    <v-card class="d-flex" color="#eeeeee">
      <v-row align="center">
        <v-col cols="2" class="assessment-title">Likelihood</v-col>
        <v-col cols="2" class="assessment-value">
          <v-select
            id="selectedLikelihoodType"
            v-model="selectedLikelihoodType"
            class="rating-select overall-rating-select"
            :items="listLikelihoodTypes"
            testing-id="selected-likelihood-type"
            :disabled="!userRatingFormControlEnabled || archivedExcursionDetected"
            density="compact"
            hide-details
            color="primary"
          >
          </v-select>
        </v-col>
        <v-col cols="2" class="assessment-title">Consequence</v-col>
        <v-col cols="2" class="assessment-value">
          <v-select
            id="selectedConsequenceType"
            v-model="selectedConsequenceType"
            class="rating-select overall-rating-select"
            :items="listConsequenceTypes"
            testing-id="selected-consequence-type"
            :disabled="!userRatingFormControlEnabled || archivedExcursionDetected"
            density="compact"
            hide-details
            color="primary"
          >
          </v-select>
        </v-col>
        <v-col cols="1" class="assessment-title">Rating</v-col>
        <v-col cols="2" class="assessment-value">
          <v-select
            id="selectedRatingType"
            v-model="selectedRatingType"
            class="rating-select overall-rating-select"
            :items="RatingTypes"
            testing-id="selected-rating-type"
            :disabled="true"
            density="compact"
            hide-details
            color="primary"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import excursionStatus from '../lib/const/excursionStatus';
import defaultRiskMatrix from '../lib/const/riskMatrixTemplate';

export default {
  props: {
    riskRatingRefname: { type: String, required: false, default: '' }
  },

  data() {
    return {
      riskAccessmentGuidePdf: '/pdf/Risk_Assessment_Guide.pdf',
      pdfOptions: {
        margin: [10, 7, 10, 5],
        filename: 'Risk_Assessment_Guide.pdf',
        pagebreak: {
          avoid: ['.risk-matrix-row']
        },
        jsPDF: {
          format: 'letter',
          orientation: 'landscape'
        }
      }
    };
  },
  computed: {
    resolvedExcursionStatus() {
      return this.$store.state.common.excursionDc.status;
    },
    userRatingFormControlEnabled() {
      return excursionStatus.APPROVED !== this.resolvedExcursionStatus;
    },
    excursionUserRiskRatingEnabled() {
      return this.$store.state.common.excursionDc.excursionUserRiskRatingEnabled;
    },
    riskMatrixSelfDefinedDetected() {
      return this.$store.state.common.excursionDc.riskMatrixSelfDefinedDetected;
    },
    listLikelihoodTypes() {
      if (this.$store.state.common.excursionDc) {
        const { riskOverallUserRating } = this.$store.state.common.excursionDc;
        if (riskOverallUserRating && String(riskOverallUserRating.likelihood).length !== 0) {
          if (this.riskMatrixSelfDefinedDetected) {
            return this.convertConsequenceOrLikelihood(
              this.$store.state.common.excursionDc.riskMatrix.likelihood ??
                this.$store.state.common.clientSettingRiskMatrix.likelihood
            );
          }
          return this.convertConsequenceOrLikelihood(defaultRiskMatrix.likelihood);
        }
      }
      return this.convertConsequenceOrLikelihood(
        this.$store.state.common.clientSettingRiskMatrix.likelihood ?? defaultRiskMatrix.likelihood
      );
    },
    listLikelihoodDefinitions() {
      if (this.$store.state.common.excursionDc) {
        const { riskOverallUserRating } = this.$store.state.common.excursionDc;
        if (riskOverallUserRating && String(riskOverallUserRating.likelihood).length !== 0) {
          if (this.riskMatrixSelfDefinedDetected) {
            return this.convertConsequenceOrLikelihoodDefinition(
              this.$store.state.common.excursionDc.riskMatrix.likelihood ??
                this.$store.state.common.clientSettingRiskMatrix.likelihood
            );
          }
          return this.convertConsequenceOrLikelihoodDefinition(defaultRiskMatrix.likelihood);
        }
      }
      return this.convertConsequenceOrLikelihoodDefinition(
        this.$store.state.common.clientSettingRiskMatrix.likelihood ?? defaultRiskMatrix.likelihood
      );
    },
    listConsequenceTypesDefinitions() {
      if (this.$store.state.common.excursionDc) {
        const { riskOverallUserRating } = this.$store.state.common.excursionDc;
        if (riskOverallUserRating && String(riskOverallUserRating.consequence).length !== 0) {
          if (this.riskMatrixSelfDefinedDetected) {
            return this.convertConsequenceOrLikelihoodDefinition(
              this.$store.state.common.excursionDc.riskMatrix.consequence ??
                this.$store.state.common.clientSettingRiskMatrix.consequence
            );
          }
          return this.convertConsequenceOrLikelihoodDefinition(defaultRiskMatrix.consequence);
        }
      }
      return this.convertConsequenceOrLikelihoodDefinition(
        this.$store.state.common.clientSettingRiskMatrix.consequence ??
          defaultRiskMatrix.consequence
      );
    },
    listConsequenceTypes() {
      if (this.$store.state.common.excursionDc) {
        const { riskOverallUserRating } = this.$store.state.common.excursionDc;
        if (riskOverallUserRating && String(riskOverallUserRating.consequence).length !== 0) {
          if (this.riskMatrixSelfDefinedDetected) {
            return this.convertConsequenceOrLikelihood(
              this.$store.state.common.excursionDc.riskMatrix.consequence ??
                this.$store.state.common.clientSettingRiskMatrix.consequence
            );
          }
          return this.convertConsequenceOrLikelihood(defaultRiskMatrix.consequence);
        }
      }

      return this.convertConsequenceOrLikelihood(
        this.$store.state.common.clientSettingRiskMatrix.consequence ??
          defaultRiskMatrix.consequence
      );
    },
    RatingTypes() {
      if (this.$store.state.common.excursionDc) {
        const { riskOverallUserRating } = this.$store.state.common.excursionDc;
        if (riskOverallUserRating && String(riskOverallUserRating.riskRating).length !== 0) {
          if (
            this.riskMatrixSelfDefinedDetected &&
            (this.$store.state.common.excursionDc.riskMatrix.riskRating ||
              this.$store.state.common.clientSettingRiskMatrix.riskRating)
          ) {
            return this.convertRiskRating(
              this.$store.state.common.excursionDc.riskMatrix.riskRating ??
                this.$store.state.common.clientSettingRiskMatrix.riskRating
            );
          }
          return this.convertRiskRating(defaultRiskMatrix.riskRating);
        }
      }

      return this.convertRiskRating(
        this.$store.state.common.clientSettingRiskMatrix.riskRating ?? defaultRiskMatrix.riskRating
      );
    },
    selectedLikelihoodType: {
      get() {
        return this.$store.state.common.excursionDc.selectedLikelihood;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_SELECTED_LIKELIHOOD, value);
      }
    },
    selectedConsequenceType: {
      get() {
        return this.$store.state.common.excursionDc.selectedConsequence;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_SELECTED_CONSEQUENCE, value);
      }
    },
    selectedRatingType: {
      get() {
        if (
          String(this.selectedLikelihoodType).length !== 0 &&
          String(this.selectedConsequenceType).length !== 0
        ) {
          const selectedRating = this.getCalculatedRatingValue(
            this.selectedLikelihoodType,
            this.selectedConsequenceType
          );
          if (selectedRating !== this.$store.state.common.excursionDc.selectedRating) {
            this.$store.commit(types.COMMON_SET_SELECTED_RATING, selectedRating);
          }
          return selectedRating;
        }
        return '';
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_SELECTED_RATING, value);
      }
    },
    tooltipBubbleTextDisplayed() {
      return typeof this.tooltipBubbleText !== 'undefined' && this.tooltipBubbleText !== '';
    },
    archivedExcursionDetected() {
      return excursionStatus.ARCHIVED === this.$store.state.common.excursionDc.status;
    }
  },
  methods: {
    async downloadRiskAssessmentGuidePdf() {
      const excursionMetadata = JSON.parse(JSON.stringify(this.$store.state.common.excursionDc));

      const { query } = this.$route;
      const clientLogoEnabled = !(query && query.referrer && query.referrer === 'pcg');

      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });

      await excursionCommonAdapter.downloadAssessmentGuidePdf(
        excursionMetadata.id,
        query,
        clientLogoEnabled,
        this.$app.deviceDetector
      );
    },
    getCalculatedRatingValue(likelihood, consequences) {
      let calculatedRating;
      const [rating0, rating1, rating2, rating3] = this.RatingTypes;

      if (this.listLikelihoodTypes[4] === likelihood) {
        switch (consequences) {
          case this.listConsequenceTypes[0]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[1]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[2]:
            calculatedRating = rating2;
            break;
          case this.listConsequenceTypes[3]:
            calculatedRating = rating3;
            break;
          case this.listConsequenceTypes[4]:
            calculatedRating = rating3;
            break;
          default:
            break;
        }
      } else if (this.listLikelihoodTypes[3] === likelihood) {
        switch (consequences) {
          case this.listConsequenceTypes[0]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[1]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[2]:
            calculatedRating = rating2;
            break;
          case this.listConsequenceTypes[3]:
            calculatedRating = rating3;
            break;
          case this.listConsequenceTypes[4]:
            calculatedRating = rating3;
            break;
          default:
            break;
        }
      } else if (this.listLikelihoodTypes[2] === likelihood) {
        switch (consequences) {
          case this.listConsequenceTypes[0]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[1]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[2]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[3]:
            calculatedRating = rating2;
            break;
          case this.listConsequenceTypes[4]:
            calculatedRating = rating3;
            break;
          default:
            break;
        }
      } else if (this.listLikelihoodTypes[1] === likelihood) {
        switch (consequences) {
          case this.listConsequenceTypes[0]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[1]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[2]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[3]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[4]:
            calculatedRating = rating2;
            break;
          default:
            break;
        }
      } else if (this.listLikelihoodTypes[0] === likelihood) {
        switch (consequences) {
          case this.listConsequenceTypes[0]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[1]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[2]:
            calculatedRating = rating0;
            break;
          case this.listConsequenceTypes[3]:
            calculatedRating = rating1;
            break;
          case this.listConsequenceTypes[4]:
            calculatedRating = rating2;
            break;
          default:
            break;
        }
      }
      return calculatedRating;
    },
    convertConsequenceOrLikelihood(value) {
      const convertedValue = Object.keys(value)
        .map((item) => ({
          sid: item,
          label: value[item].label,
          description: value[item].description,
          orderIndex: value[item].orderIndex
        }))
        .sort((a, b) => a.orderIndex - b.orderIndex);
      return convertedValue.map((item) => item.label);
    },
    convertConsequenceOrLikelihoodDefinition(value) {
      const convertedValue = Object.keys(value)
        .map((item) => ({
          sid: item,
          label: value[item].label,
          description: value[item].description,
          orderIndex: value[item].orderIndex
        }))
        .sort((a, b) => a.orderIndex - b.orderIndex);
      return convertedValue.map((item) => item.description);
    },
    convertRiskRating(value) {
      const convertedValue = Object.keys(value)
        .map((item) => ({
          sid: item,
          label: value[item].label,
          orderIndex: value[item].orderIndex
        }))
        .sort((a, b) => a.orderIndex - b.orderIndex);
      return convertedValue.map((item) => item.label);
    }
  }
};
</script>
<style scoped>
.risk-rating-overall {
  width: 100%;
  margin-bottom: 20px;
}

.risk-rating-overall .assessment-title {
  line-height: 50px;
  padding-right: 5px;
  text-align: right;
}

.risk-rating-overall .assessment-value {
  padding-left: 5px;
  text-align: left;
}

.confirmation-info-text {
  padding-bottom: 10px;
  color: rgb(0, 0, 0, 0.6);
  font-size: 14px;
}

.confirmation-info-text .v-icon {
  padding-bottom: 2px;
  font-size: 14px;
  margin-right: 3px;
}

.overall-rating-select {
  width: 130px;
}

.link-primary {
  color: rgb(var(--v-theme-primary));
}

::v-deep(.rating-select .v-select__selection) {
  font-size: 14px;
}

.risk-rating-overall-form-label {
  font-size: 14px;
  font-weight: 600 !important;
  color: #000000 !important;
  padding: 10px 0 10px 0;
}
</style>
